/**============================================================
*   [fixedLayoutScroll]
*   description : fixed要素を横スクロールできない問題を回避する処理を記述
============================================================*/
document.addEventListener('DOMContentLoaded', function() {
  function fixedScroll(){
    if(window.matchMedia('(min-width:767px)').matches) {
      $('.l-header').css("left", -$(window).scrollLeft());
    }else{
      //mobile
      $('.l-header').css("left",0);
    }
  }
  window.addEventListener('load', fixedScroll, true);
  window.addEventListener('scroll', fixedScroll, true);
  window.addEventListener('resize', fixedScroll, true);
});
